import { invalidateCache } from 'api/urql/helpers/mutation';

export const createVenue = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('paginatedVenues')(results, args, cache, info);
};
